// Calendar view

import $ from "jquery";
import size from '../base/_size';
import debug from 'bows/dist/bows.min.js';


let $single = $('[data-slider="single"]');


const $body = $('body');
const log = debug("sliders:single-small");



function sliderInit() {
	$single.each(function () {
		let $this = $(this);
		let role = $this.attr('role');
		let $singleslider = $this.closest('.single-slider');
		let prev = $singleslider.find('[data-direction="prev"]');
		let next = $singleslider.find('[data-direction="next"]');
		let slider = '';
		let total = $this.children().length;
		let totalSlides = $singleslider.find('.single-slider__total');
		let theCurrentSlide = $singleslider.find('.single-slider__current');


		if (total < 10) {
			total = '0' + total;
		}
		totalSlides.text(total);

		if (role !== 'region') {
			slider = $this.slick({
				dots: false,
				mobileFirst: true,
				speed: 500,
				infinite: true,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1
			});
			window.sliderArray.push(slider);
		}

		prev.on('click', function () {
			slider.slick('slickPrev');
		});
		next.on('click', function () {
			slider.slick('slickNext');
		});
		slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {

			//currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
			var i = (currentSlide ? currentSlide : 0) + 1;
			if (i < 10) {
				i = '0' + i;
			}
			theCurrentSlide.text(i);
		});
	});


}


export function init() {
	if ($single.length) {
		sliderInit();
	}
}

export default {
	init
};
